import Vue from 'vue';
import App from './App.vue';
import router from './router';
import LoadScript from 'vue-plugin-load-script';
window.axios = require('axios');
var VueScrollTo = require('vue-scrollto');
import VueClipboard from 'vue-clipboard2';
import store from './store'
import { initViberaryGa4, trackAnalyticsEvent } from './analytics/viberaryGa4';
import './assets/homepage-v23.css';
import './assets/download-v23.css';

Vue.use(VueClipboard)
Vue.use(VueScrollTo)

//window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
Vue.use(LoadScript);
Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^ion-/];

window.viberaryAnalytics = window.viberaryAnalytics || {
  supportedEvents: [
    'track_impression', 'track_card_click', 'audio_play', 'audio_pause',
    'download_page_view', 'download_click', 'filter_apply',
    'load_more_click', 'pagination_click', 'related_track_click'
  ],
  events: [],
  track(eventName, dimensions = {}) {
    const payload = {
      event: eventName,
      dimensions,
      timestamp: new Date().toISOString(),
      staging: window.location.hostname.includes('preview-7q9')
    };
    this.events.push(payload);
    if (window.location.hostname.includes('preview-7q9')) {
      console.info('[Viberary staging analytics]', payload);
    }
    trackAnalyticsEvent(eventName, dimensions);
  }
};
window.viberaryTrackEvent = function(eventName, dimensions = {}) {
  window.viberaryAnalytics.track(eventName, dimensions);
};

initViberaryGa4(router);

new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')
